import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { mockCompanyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="text-gray-300 !bg-[#092B84]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_a4932d93-1a08-4aba-97f8-fc665534a903/artifacts/e6h6bxv7_BF726A6E-A369-4D1E-89C3-313F853560BC_1_105_c.jpeg"
                alt="BCS Industrial Coating and Repair Services Logo"
                width="64"
                height="64"
                loading="lazy"
                className="h-16 w-16 object-cover"
                style={{ clipPath: 'circle(37% at center)' }}
              />
            </div>
            <p className="!text-sm mb-4">
              BCS, a division of Corrosion Analytics™
            </p>
            <div className="flex items-center text-sm">
              <Phone size={16} className="mr-2 flex-shrink-0" />
              <a href="tel:+19493719948" className="hover:text-white transition-colors">{mockCompanyInfo.phone}</a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/services/protective-coatings')} className="hover:text-white transition-colors text-left">
                  Protective Coatings
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services/hvac-repair')} className="hover:text-white transition-colors text-left">
                  HVAC & Cooling Repairs
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services/pipeline-repair')} className="hover:text-white transition-colors text-left">
                  Pipeline Repairs
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services/structural-repair')} className="hover:text-white transition-colors text-left">
                  Structural Repair
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services/equipment-repair')} className="hover:text-white transition-colors text-left">
                  Equipment Restoration
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/services/tank-repair')} className="hover:text-white transition-colors text-left">
                  Tank Repairs
                </button>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-white font-semibold mb-4">Industries</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/industries/manufacturing')} className="hover:text-white transition-colors text-left">
                  Manufacturing
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/industries/oil-gas')} className="hover:text-white transition-colors text-left">
                  Oil & Gas
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/industries/power')} className="hover:text-white transition-colors text-left">
                  Power Generation
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/industries/water-wastewater')} className="hover:text-white transition-colors text-left">
                  Water & Wastewater
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/industries/marine')} className="hover:text-white transition-colors text-left">
                  Marine & Offshore
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/industries/petrochemical')} className="hover:text-white transition-colors text-left">
                  Petrochemical
                </button>
              </li>
            </ul>
          </div>

          {/* Research & Learn */}
          <div>
            <h3 className="text-white font-semibold mb-4">Research & Learn</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/research-learn')} className="hover:text-white transition-colors text-left">
                  Blog & Articles
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/research/corrosion-rust')} className="hover:text-white transition-colors text-left">
                  Corrosion & Rust
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/research/leaks-seepage')} className="hover:text-white transition-colors text-left">
                  Leaks & Seepage
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/research/erosion-wear')} className="hover:text-white transition-colors text-left">
                  Erosion & Wear
                </button>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-white font-semibold mb-4">Service Areas</h3>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => navigate('/service-areas/california')} className="hover:text-white transition-colors text-left">California</button></li>
              <li><button onClick={() => navigate('/service-areas/southern-california')} className="hover:text-white transition-colors text-left">Southern California</button></li>
              <li><button onClick={() => navigate('/service-areas/los-angeles')} className="hover:text-white transition-colors text-left">Los Angeles</button></li>
              <li><button onClick={() => navigate('/service-areas/orange-county')} className="hover:text-white transition-colors text-left">Orange County</button></li>
              <li><button onClick={() => navigate('/service-areas/san-diego')} className="hover:text-white transition-colors text-left">San Diego</button></li>
              <li><button onClick={() => navigate('/service-areas/long-beach')} className="hover:text-white transition-colors text-left">Long Beach</button></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => navigate('/about/why-choose-bcs')} className="hover:text-white transition-colors text-left">
                  About BCS
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-choose-bcs')} className="hover:text-white transition-colors text-left">
                  Why Choose Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('warranties')} className="hover:text-white transition-colors text-left">
                  Warranties
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/careers')} className="hover:text-white transition-colors text-left">
                  Careers
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors text-left">
                  Contact Us
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/customer-portal')} className="hover:text-white transition-colors text-left flex items-center gap-1">
                  Customer Portal <ArrowRight size={12} />
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-blue-700 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {currentYear} BCS. All rights reserved.
          </p>
          <div className="flex items-center gap-4 mt-4 md:mt-0">
            <button
              onClick={() => navigate('/about/privacy-policy')}
              className="text-sm text-gray-400 hover:text-white transition-colors"
              data-testid="footer-privacy-policy-link"
            >
              Privacy Policy
            </button>
            <span className="text-gray-500">|</span>
            <button
              onClick={() => navigate('/about/legal-disclaimer')}
              className="text-sm text-gray-400 hover:text-white transition-colors"
              data-testid="footer-legal-disclaimer-link"
            >
              Legal Disclaimer
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;